import { useLanguage } from "../i18n";

/**
 * When it happened, as taps.
 *
 * Relative presets, never a wheel picker or split dropdowns: the question is
 * always "roughly when", and a date control asks for a precision nobody has
 * about a plant they carried indoors at some point last week.
 *
 * Shared by the soil log and the move control so the two cannot drift apart —
 * the same four answers, in the same order, meaning the same thing.
 */
export const WHEN = [
  { key: "whenNow" as const, hoursAgo: 0 },
  { key: "whenEarlier" as const, hoursAgo: 6 },
  { key: "whenYesterday" as const, hoursAgo: 24 },
  { key: "whenTwoDays" as const, hoursAgo: 48 },
];

/** The moment a chosen preset refers to, or undefined for "now". */
export function occurredAt(index: number): Date | undefined {
  const hours = WHEN[index]?.hoursAgo ?? 0;
  if (hours === 0) return undefined;
  return new Date(Date.now() - hours * 3600_000);
}

export function WhenRow({
  index,
  onChange,
}: {
  index: number;
  onChange: (index: number) => void;
}) {
  const { t } = useLanguage();
  return (
    <div className="chips when-row">
      <span className="when-label">{t.when}</span>
      {WHEN.map((option, i) => (
        <button
          key={option.key}
          type="button"
          className="chip when"
          aria-pressed={index === i}
          onClick={() => onChange(i)}
        >
          {t[option.key]}
        </button>
      ))}
    </div>
  );
}
